import React, {
  useEffect, useState,
} from 'react';

import CommitForm from '../../../../components/CommitForm';
import ContentCard from '../../../../components/ContentCard';
import { useUpdateClassMutation } from '../../../../services/classes';
import { Class } from '../../../../services/classes/types';
import { useGetCoursesQuery } from '../../../../services/courses';
import { useGetStreamsQuery } from '../../../../services/streams';
import { Metadata } from '../../../../services/types';
import useError from '../../../../utils/react/hooks/useError';
import useSuccess from '../../../../utils/react/hooks/useSuccess';

interface CourseCardProps {
  classObj: Class;
  classObjMetadata?: Metadata;
}

const CourseCard = ({ classObj, classObjMetadata }: CourseCardProps) => {
  const [updateClass, { isLoading: isUpdating,
    isError: isUpdateClassError,
    error: updateClassError,
    isSuccess: isUpdateClassSuccess }] = useUpdateClassMutation();

  const [newCourse, setNewCourse] = useState(classObj.course);

  const { data: streams } = useGetStreamsQuery({ course: newCourse });
  const { data: courses } = useGetCoursesQuery({ subject: classObj.subject });

  const [metadata, setMetadata] = useState(classObjMetadata);
  const [newClassObj, setNewClassObj] = useState(classObj);

  useEffect(() => {
    if (classObjMetadata && streams && courses) {
      setMetadata({
        ...classObjMetadata,
        course: {
          ...classObjMetadata?.course,
          typeOptions: courses?.data.map((course) => ({
            value: course.id,
            label: course.shortLabel,
          })) || [],
        },
        stream: {
          ...classObjMetadata?.stream,
          typeOptions: streams?.data.map((stream) => ({
            value: stream.streamId,
            label: stream.shortLabel,
          })) || [],
        },
      });

      // If the stream is not the original stream, reset it
      if (!streams?.data.find((stream) => stream.streamId === classObj.stream)) {
        setNewClassObj({
          ...classObj,
          stream: '',
        });
      } else {
        setNewClassObj(classObj);
      }
    }
  }, [classObjMetadata, classObj, streams, courses]);

  useError(isUpdateClassError, updateClassError);
  useSuccess(isUpdateClassSuccess, 'Class updated');

  return (
    <ContentCard
      title="Course"
      variant="outlined"
      buttons={[{
        label: 'View Stream',
        href: `/admin/course/${classObj.subject}/${classObj.course}/${classObj.stream}`,
      }]}
    >
      <CommitForm
        data={newClassObj}
        metadata={metadata}
        fields={{
          course: {
            xs: 12,
            md: 12,
          },
          stream: {
            xs: 12,
            md: 12,
          },
          schoolTag: {
            xs: 12,
            md: 12,
          },
        }}
        onChange={(changes) => {
          if (changes.course) {
            // Update stream options
            setNewCourse(changes.course);
          }
        }}
        // Reset stream options on discard
        onDiscard={() => setNewCourse(classObj.course)}
        onSubmit={(changes) => updateClass({
          subject: classObj.subject,
          classId: classObj.classId,
          newAttributes: changes,
        })}
        isSubmitLoading={isUpdating}
      />
    </ContentCard>
  );
};
export default CourseCard;
